import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Using External Svelte Components",
description: "Learn how to customize the Freon editor with external Svelte components—adding icons, buttons, accordions, and a sortable table—using libraries like Flowbite or your own components.",
tags: [ "Freon", "Svelte", "external components", "editor customization", "Flowbite", "styling", "Accordion", "icons", "buttons", "sortable table", "CourseSchedule", "projections"] ,
modifiedTime: "2025-11-07T18:14:45.626Z",
publishedTime: "2025-11-07T17:20:18.642Z"
    }
  };
};